import React from 'react';
import { Request } from '../../services/requestsService';
import { formatDateTime } from '../../utils/dateUtils';

interface FlightInfoSectionProps {
  task: Request;
}

const FlightInfoSection: React.FC<FlightInfoSectionProps> = ({ task }) => {
  return (
    <div className="task-detail-section">
      <h2>Информация о рейсе</h2>
      <div className="task-detail-grid">
        <div className="task-detail-item">
          <span className="task-detail-label">Номер рейса:</span>
          <span className="task-detail-value">{task.flight?.flightNumber}</span>
        </div>
        <div className="task-detail-item">
          <span className="task-detail-label">Маршрут:</span>
          <span className="task-detail-value">
            {task.flight?.departureAirport} → {task.flight?.arrivalAirport}
          </span>
        </div>
        <div className="task-detail-item">
          <span className="task-detail-label">Время вылета:</span>
          <span className="task-detail-value">
            {task.flight?.departureTime ? formatDateTime(task.flight.departureTime) : 'Не указано'}
          </span>
        </div>
        <div className="task-detail-item">
          <span className="task-detail-label">Время прилета:</span>
          <span className="task-detail-value">
            {task.flight?.arrivalTime ? formatDateTime(task.flight.arrivalTime) : 'Не указано'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FlightInfoSection; 